import { useTranslation } from "react-i18next";
import { NoObjectChosen } from "../../common/NoObjectChosen";
import { CaseCreator } from "./Components/CaseCreator";
import { useStorageSelectors } from "../../app/state/storageObjectSlice/hook/use-storage-selectors";
import { useAppSelector } from "../../services/redux/hooks/use-selector";
import { selectCaseMode } from "./redux/selectors";
import { CasesTable } from "./Components/CasesTable";
import { useAppModals } from "../../app/state/modalSlice/hook/use-app-modals";

export const Cases = () => {
  const { selectedObject } = useStorageSelectors("cases");
  const { t } = useTranslation();
  const caseMode = useAppSelector(selectCaseMode);
  const { handleOpenModal } = useAppModals();

  if (selectedObject?.value === null) {
    return (
      <NoObjectChosen
        message={t("cases.no_object_message")}
        folderName={selectedObject.friendly_name}
        onClick={() =>
          handleOpenModal(
            "object_manager",
            { id: selectedObject?.id, value: "child" },
            "create_object",
          )
        }
      />
    );
  }

  return <>{caseMode === "create" ? <CaseCreator /> : <CasesTable />}</>;
};
